import apiClient from "./axiosConfig"

const url = '/admin'
const auditUrl = '/auth/audit'

const getAdminDashboardOverview = async () => await apiClient.get(url + '/overview/')
const getJobPostings = async (params = {}) => { 
    // const { page = 1, page_size = 10, ...filters } = params;
  
//   const queryParams = new URLSearchParams({
//     page: page.toString(),
//     page_size: page_size.toString(),
//     ...filters
//   });
    return await apiClient.get(`${url}/job-postings/list`, { params });
}

const getUsers = async(params = {}) => await apiClient.get(`${url}/users/list`, { params })
const createUser = async(data) => await apiClient.post(`${url}/users/create/`, data)
const updateUser = async(id, data) => await apiClient.put(`${url}/users/${id}/update/`, data)
const patchUser = async(id, data) => await apiClient.patch(`${url}/users/${id}/update/`, data)
const getJobPostingDetails = async (id) => await apiClient.get(`${url}/job-postings/${id}/`)
const getJobApplications = async (params = {}) => await apiClient.get(`${url}/applications/list`, { params })
const getJobApplicationDetails = async (id) => await apiClient.get(`${url}/applications/${id}/`)
const getUserDetails = async (id) => await apiClient.get(`${url}/users/${id}/`)
const activateOrDeactivateUser = async (id, is_active) => {
    let payload = {action: 'activate'}
    if(is_active) {
        payload.action = 'activate'
    } else {
        payload.action = 'deactivate'
    }
    return await apiClient.post(`${url}/users/${id}/activate/`, payload)
}

const getSubscriptions = async(params = {}) => await apiClient.get(`${url}/subscriptions/list/`, { params })
const getSubscriptionDetails = async (id) => await apiClient.get(`${url}/subscriptions/${id}/`)
const updateSubscriptionStatus = async(id, action, reason='', end_date) => await apiClient.post(`${url}/subscriptions/${id}/activate/`, {
    action,
    reason,
    end_date
  })
const getSubscriptionPlans = async(params = {}) => await apiClient.get(`${url}/subscription-plans/list/`, { params })
const createSubscriptionPlan = async(data) => await apiClient.post(`${url}/subscription-plans/create/`, data)
const deleteSubscriptionPlan = async(id) => await apiClient.delete(`${url}/subscription-plans/${id}/delete/`)
const updateSubscriptionPlan = async(id, data) => await apiClient.put(`${url}/subscription-plans/${id}/update/`, data)
const updatePlanStatus = async(id, action, reason= '') => await apiClient.post(`${url}/subscription-plans/${id}/activate/`, { action, reason})
const getSubscriptionPlanDetails = async(id) => await apiClient.get(`${url}/subscription-plans/${id}/`)
const getPayments = async (params = {}) => await apiClient.get(`${url}/payments/list/`, {params})
const getPaymentDetails = async (id) => await apiClient.get(`${url}/payments/${id}/`)
const professionalVerificationStatus = async (id) => await apiClient.get(`${url}/professionals/${id}/verification/`)

const verifyProfessional = async(id, data) => await apiClient.post(`${url}/professionals/${id}/verification/`, data)

const bulkVerifyDocuments = async(userId, data={}) => await apiClient.post(`${url}/professionals/${userId}/verification/bulk-documents/`, data)
const verifyIndividualDocument = async(userId, documentId, data) => await apiClient.put(`${url}/professionals/${userId}/verification/documents/${documentId}/`, data)

// Audit Trail
const getAuditTrails = async(params = {}) => await apiClient.get(auditUrl + '/', {params})
const getAuditStatistics = async() => await apiClient.get(auditUrl + '/stats/')
const getAuditTrailDetails = async(id) => await apiClient.get(`${auditUrl}/${id}/`)
const getMyRecentActivity = async() => await apiClient.get(auditUrl + '/me/')

// Payment Configuration
const getPaymentConfigs = async () => await apiClient.get(`${url}/payment-config/`)
const updatePaymentGatewayConfig = async (gateway, data) => await apiClient.patch(`${url}/payment-config/${gateway}/`, data)

export default {
    getAdminDashboardOverview,
    getJobPostings,
    getUsers,
    updateUser,
    patchUser,
    createUser,
    getJobPostingDetails,
    getJobApplications,
    getJobApplicationDetails,
    getUserDetails,
    activateOrDeactivateUser,
    getSubscriptions,
    getSubscriptionDetails,
    updateSubscriptionStatus,
    getSubscriptionPlans,
    createSubscriptionPlan,
    deleteSubscriptionPlan,
    updateSubscriptionPlan,
    getSubscriptionPlanDetails,
    getPayments,
    getPaymentDetails,
    updatePlanStatus,
    professionalVerificationStatus,
    verifyProfessional,
    bulkVerifyDocuments,
    verifyIndividualDocument,
    getAuditTrails,
    getAuditStatistics,
    getAuditTrailDetails,
    getMyRecentActivity,
    getPaymentConfigs,
    updatePaymentGatewayConfig
}